export enum SignatureMode {
  TIMESTAMP = 'timestamp',
  ADVANCED = 'advanced',
  QUALIFIED = 'qualified'
}
